import {
  Body,
  Box,
  Button,
  Container,
  ContainerProps,
  Heading,
  SimpleGrid,
} from '@hover/blueprint';
import React, { useState } from 'react';
import { DownloadAppModal } from '..';

interface Props extends ContainerProps {
  header: string;
  body: string;
  backgroundColor: string;
  showCtaButton?: boolean;
}

const HoInvitedHero: React.FC<Props> = ({
  header,
  body,
  backgroundColor,
  showCtaButton,
  children,
  ...restProps
}) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const toggleModal = () => setOpen(!isOpen);
  return (
    <Box w="100%" bg={backgroundColor} mb={{ base: '75px', tablet: 1000 }}>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container maxW="8xl" pt={{ base: 700, desktop: 0 }} px={0}>
        <SimpleGrid columns={{ base: 1, desktop: 2 }}>
          <Container
            maxW="xl"
            mt={{ base: 0, desktop: 1000 }}
            d="flex"
            flexDir="column"
            alignItems={{ base: 'center', desktop: 'flex-start' }}
            {...restProps}
          >
            <Heading
              color={{ base: 'neutral.0', tablet: 'neutral.0' }}
              size={{ base: 600, tablet: 700, desktop: 800 }}
              textAlign={{ base: 'center', desktop: 'left' }}
              style={{ marginBottom: 24, fontWeight: 700 }}
            >
              {header}
            </Heading>
            <Body
              textAlign={{ base: 'center', desktop: 'left' }}
              size={500}
              maxW="md"
              mb={700}
              color="neutral.0"
            >
              {body}
            </Body>
            <Button
              onClick={toggleModal}
              size="large"
              d={showCtaButton ? 'flex' : 'none'}
              w={{ base: '100%', tablet: 'auto' }}
            >
              <Body size={400} color="neutral.0" isBold>
                TRY IT ON YOUR HOME
              </Body>
            </Button>
          </Container>
          {children}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

HoInvitedHero.defaultProps = {
  showCtaButton: false,
};

export default HoInvitedHero;
